<template>
  <v-dialog
    v-model="dialog"
    persistent
    scrollable
    max-width="500px"
  >
    <v-card :loading="loading">
      <v-card-title>
        <span>Tra cứu thông tin</span>
        <v-spacer/>
        <v-menu
          bottom
          left
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              @click="close()"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </template>
        </v-menu>
      </v-card-title>
      <v-card-text>
        <div v-if="errors_exist" class="row">
          <div class="col">
            <v-alert
              dense
              outlined
              type="error"
            >
              {{ $vuetify.lang.t('$vuetify.msg.hasError') }}
              <ul>
                <div v-for="(error, index) in errors">
                  <li :key="index">{{ error[0] }}</li>
                </div>
              </ul>
            </v-alert>
          </div>
        </div>
        <v-row>
          <v-col cols="12">
            <v-text-field
              v-model="tuNgay"
              label="Từ ngày"
              v-mask="'##/##/####'"
              hide-details
              clearable
            />
          </v-col>
          <v-col cols="12">
            <v-text-field
              v-model="denNgay"
              label="Đến ngày"
              v-mask="'##/##/####'"
              hide-details
              clearable
            />
          </v-col>
          <v-col cols="12">
            <v-select
              v-model="typeSelected"
              :items="types"
              item-text="dien_giai"
              item-value="id"
              label="Loại"
              hide-details
              clearable
            />
          </v-col>
          <v-col cols="12">
            <v-select
              v-model="levelSelected"
              :items="levels"
              item-text="text"
              item-value="value"
              label="Mức độ"
              hide-details
              clearable
            />
          </v-col>
          <v-col cols="12">
            <v-select
              v-model="statusSelected"
              :items="status"
              item-text="text"
              item-value="value"
              label="Tình trạng"
              hide-details
              clearable
            />
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="py-5 justify-center">
        <v-btn
          @click="close"
        >
          Hủy bỏ
        </v-btn>
        <v-btn
          color="primary"
          @click="filter"
        >
          Xem trước
        </v-btn>
        <v-btn
          color="success"
          @click="exportData"
        >
          Xuất thông tin
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
  import FileSevice from '@/services/File';
  export default {
    props: {
      showDialog: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        loading: false,
        dialog: false,
        errors_exist: false,
        errors: [],
        types: [],
        status: [
          {value: '0', text: 'Bí mật'},
          {value: '1', text: 'Công khai'}
        ],
        levels: [
          {value: 'DANGER', text: 'Khẩn cấp'},
          {value: 'WARNING', text: 'Cảnh báo'},
          {value: 'NORMAL', text: 'Bình thường'},
          {value: 'PREDICT', text: 'Dự báo'}
        ],
        typeSelected: null,
        statusSelected: null,
        levelSelected: null,
        tuNgay: null,
        denNgay: null,
      }
    },
    mounted() {
      this.dialog = this.showDialog;
    },
    watch: {
      showDialog() {
        this.dialog = false;
        this.errors_exist=false;
        if (this.showDialog) {
          this.dialog = true;
          this.getTypes();
        }
      }
    },
    methods: {
      getTypes () {
        axios.get("api/v1/news-categories")
          .then(response => {
            this.types = response.data;
          })
          .catch(function (error) {
            console.log(error);
          });
      },
      close() {
        this.dialog = false;
        this.$emit('cancelled');
      },
      filter() {
        this.$emit('confirmed', {
          tuNgay: this.tuNgay,
          denNgay: this.denNgay,
          loaiTin: this.typeSelected,
          mucDo: this.levelSelected,
          tinhTrang: this.statusSelected
        });
        this.dialog = !this.dialog;
      },
      exportData(){
        const app = this;
        app.loading=true;
        let params = {
          namereport: 'thong_tin',
          export_type: 'xlsx',
          filter: {
            tuNgay: app.tuNgay,
            denNgay: app.denNgay,
            loaiTin: app.typeSelected,
            mucDo: app.levelSelected,
            tinhTrang: app.statusSelected
          }
        };
        axios.post('api/v1/export', params, {responseType: 'arraybuffer'})
          .then(function (response) {
            FileSevice.download(response.data, `thong_tin.xlsx`);
            app.loading=false;
          }).catch(function (error) {
            console.log(error);
          });
      }
    }
  }
</script>